/**
 * Utility functions for loading data from local JSON files
 */
import contributionData from '../data/contribution.json';
import contestData from '../data/contest.json';
import bountyData from '../data/bounty.json';
import topFindingData from '../data/top-finding.json';
import auditData from '../data/audit.json';

import { sortByDate } from './sortUtils';

/**
 * Get data from local JSON files
 * @param {string} dataType - Type of data to fetch
 * @param {Object} options - Options for data processing
 * @returns {Array} The requested data
 */
export const getData = (dataType, options = {}) => {
  let data;
  
  // Select the appropriate data source based on dataType
  switch (dataType) {
    case 'contributions':
      data = [...contributionData];
      break;
    case 'contests':
      data = [...contestData];
      break;
    case 'bounties':
      data = [...bountyData];
      break;
    case 'top-findings':
      data = [...topFindingData];
      break;
    case 'audits':
      data = [...auditData];
      break;
    default:
      throw new Error(`Unknown data type: ${dataType}`);
  }
  
  // Apply sorting if needed
  if (options.sort === 'date') {
    return sortByDate(data, options.sortOrder);
  }
  
  return data;
};
